<template>
  <div class="button-grid">
    <button-component
      v-for="(disease, index) in diseases"
      :key="index"
      :index="index"
      :disable="disableDiseases[index]"
      methods="toggleActive"
      :buttonLabel="disease"
      @toggleActive="toggleActive"
      :class="{
        active: diseasesData[index] === true,
        disable: disableDiseases[index] === true
      }"
      :data-test="`${disease}`"
    />
  </div>
</template>

<script>
import VueTypes from "vue-types";
import ButtonComponent from "../../atoms/Button";

export default {
  props: {
    diseasesData: VueTypes.objectOf(VueTypes.bool.isRequired),
    disableDiseases: VueTypes.objectOf(VueTypes.bool.isRequired)
  },
  components: {
    ButtonComponent
  },
  computed: {
    diseases() {
      return this.$store.state.labels.diseaseNames;
    }
  },
  methods: {
    toggleActive(index) {
      this.$emit("toggelActiveDiseaseHistory", index);
    }
  }
};
</script>

<style scoped>
.button {
  padding: 7px;
  border: 1px solid #d8d8d8;
  color: #d8d8d8;
  margin-right: 10px;
  margin-bottom: 10px;
  width: 130px;
  height: 40px;
}
.button-grid {
  width: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
}
.active {
  background-color: #c5d7ef !important;
  color: #ffffff;
}
.disable {
  background-color: #e8e8e8 !important;
  color: #ffffff;
}
.disable:hover {
  cursor: default;
}
</style>
